import { BulkImportType } from '../../../../../types';
import { BulkOpsSchema } from './create-bulk-op-dialog';

export const getBulkOpsSchema = (bulkImportType: BulkImportType[] = []) => {
  return BulkOpsSchema.superRefine((data, ctx) => {
    const selectedBulkImportType = bulkImportType.find(
      (type) => type.name == data.bulkImport
    );

    if (selectedBulkImportType) {
      if (
        selectedBulkImportType.columns &&
        selectedBulkImportType.columns.length > 0
      ) {
        if (data.columns && data.columns.length <= 0) {
          ctx.addIssue({
            code: 'custom',
            message: 'Please select at least one column before moving on.',
            path: ['columns'],
          });
        }
      }
    }
  });
};
